import { render, staticRenderFns } from "./JourneyCalendar.vue?vue&type=template&id=52f256fa&lang=pug&functional=true&"
import script from "./JourneyCalendar.vue?vue&type=script&lang=js&"
export * from "./JourneyCalendar.vue?vue&type=script&lang=js&"
import style0 from "./JourneyCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports